import Contents from "./contents";
import type { StepType } from "@reactour/tour";
import TourStepContent from "../../wrapper";
import { text } from "@quickpoint.me/shared";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";

const intro: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.fullWelcome}
						<br />
						<span>
							{text.tourSteps.origWelcomeInstructions}
						</span>
					</span>
				)}
			/>
		),
		position: "center",
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: " " });
		},
	},
	{
		selector: ".tour",
		content: () => (
			<TourStepContent description={() => text.tourSteps.origRevisitGuide} />
		),
	},
	{
		selector: "window",
		content: Contents,
		position: "center",
	},
];

export default intro;
